// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"4530244e","249":"4530244e","693":"4530244e","940":"774f2ca7"}[chunkId] + ".chunk.css";
};